import { DesktopMenu } from "../App";
import RSVP from "../components/RSVP";

export default function Home() {
  return (
    <>
      <div className="px-0 md:px-8 max-w-[1500px] mx-auto">
        {/* Intro video */}
        <div className="flex flex-col max-w-[750px] w-full mx-auto relative text-[31px] md:text-[90px] font-tildaGrande text-white">
          <div className="absolute text-nowrap text-center md:text-left w-full md:w-auto left-0 md:-left-6">Patrick & Raenna are getting married</div>
          <video src="/intro.mp4" autoPlay muted loop playsInline className="mt-12 md:mt-[5.75rem] mb-10 md:mb-[6rem] aspect-video"></video>
          <div className="absolute bottom-0 right-0 pr-[0.5px]">and you're invited <span className="text-secondary-light">❧</span></div>
        </div>

        <div className="flex flex-col gap-16 md:gap-8 text-secondary font-archer mb-24">
          {/* Ceremony */}
          <div className="flex flex-col md:flex-row items-stretch justify-center gap-6 mx-4 md:mx-0">
            <div className="w-full md:w-[420px] bg-secondary-light rounded-md relative h-[250px] md:h-auto shrink-0">
              <img src="/ceremony.png" alt="Ceremony" className="absolute w-full h-full inset-0 object-contain"/>
            </div>
            <div className="p-8 rounded-md text-[26px] grow flex flex-col gap-2 bg-linen px-12">
              <div className="font-semibold">
                We request the pleasure of your company in the celebration of
                our lifelong friendship and lifetime of marriage. Please see details below.​
              </div>
              <div>
                <span className="font-medium">When:</span> <span className="italic">​Tuesday 13 October 2026, 11am</span>
              </div>
              <div>
                <div>
                  <span className="font-medium">Where:</span> <a href="https://www.google.com/maps/place/De+Vere+Tortworth+Court/@51.6307605,-2.4469803,17z/data=!4m9!3m8!1s0x487198c3b7d6159f:0xab56a5d56777693e!5m2!4m1!1i2!8m2!3d51.6307605!4d-2.4444054!16zL20vMDhueGJi?entry=ttu&g_ep=EgoyMDI1MTExNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer" className="italic underline hover:no-underline">​The Orangery at De Vere Tortworth Court</a>
                </div>
                <div className="text-sm font-light">Tortworth, Wotton-under-Edge GL12 8HH, UK</div>
              </div>
            </div>
          </div>

          {/* Reception */}
          <div className="flex flex-col-reverse md:flex-row items-stretch justify-center gap-6 mx-4 md:mx-0">
            <div className="bg-linen p-8 rounded-md text-[26px] grow flex flex-col gap-2 px-12">
              <div className="font-semibold">
                Drinks and dinner will follow at this location and time:
              </div>
              <div>
                <span className="font-medium">When:</span> <span className="italic">​Same day, 7pm onwards</span>
              </div>
              <div>
                <div>
                  <span className="font-medium">Where:</span> <a href="https://maps.app.goo.gl/am12sNar6Y7DyaEJA" target="_blank" rel="noreferrer" className="italic underline hover:no-underline">Kasa & Kin</a>
                </div>
                <div className="text-sm font-light">52-53 Poland St, London W1F 7NQ, United Kingdom</div>
              </div>
            </div>
            <div className="w-full md:w-[420px] bg-secondary-light rounded-md relative h-[250px] md:h-auto shrink-0">
              <img src="/ramo.png" alt="food" className="absolute w-full h-full inset-0 object-contain scale-[0.9]"/>
            </div>
          </div>
        </div>

        {/* RSVP */}
        <div className="pb-12 md:pb-0">
          <RSVP />
        </div>
      </div>

    <div className="pt-12 hidden md:block">
      <DesktopMenu />
    </div>
    </>
  );
};
